var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"LeasePeriodsTableSemesters"},[_vm._l((_vm.leasePeriod.semesters),function(semester){return [_c('span',{key:semester.id},[_vm._v(_vm._s(semester.name)+" ")]),_c('br',{key:semester.id})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }